
import MonthsRent from "./MonthsRent";
export default MonthsRent